import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { t } from 'ttag';

import { Title } from '@ui/Title';
import { Button } from '@ui/Button';

import s from './ProductDetailsDescription.sss';

const MAX_DESCRIPTION_SYMBOLS_LENGTH = 700;

interface Props {
  className?: string,
  description: string,
}

export const ProductDetailsDescription: React.FC<Props> = ({
  className,
  description,
}) => {
  const [isMoreButtonVisible, setIsMoreButtonVisible] = useState(false);
  const descriptionRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    if (descriptionRef.current) {
      if (description.length > MAX_DESCRIPTION_SYMBOLS_LENGTH) {
        descriptionRef.current.innerHTML = `${description.slice(0, MAX_DESCRIPTION_SYMBOLS_LENGTH)}...`;
  
        setIsMoreButtonVisible(true);
      }
    }
  }, [description]);

  const handleShowMore = () => {
    if (descriptionRef.current) {
      descriptionRef.current.innerHTML = description;
      setIsMoreButtonVisible(false);
    }
  };

  return (
    <div className={classNames(s.root, className)}>
      <Title
        className={s.title}
        type='h6'
        bold={false}
      >
        {t`Опис`}
      </Title>

      <div className={s.holder}>
        <p
          ref={descriptionRef}
          className={s.description}
        >
          {description}
        </p>

        {isMoreButtonVisible && (
          <Button
            className={s.button}
            theme='text'
            onClick={handleShowMore}
          >
            {t`читати далі`}
          </Button>
        )}
      </div>
    </div>
  );
};
